import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tt-table-border",
  "use": "icon-tt-table-border-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol viewBox=\"0 0 28 28\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-tt-table-border\">\n<path d=\"M21.1429 4C22.7188 4 24 5.27902 24 6.85714V21.1429C24 22.7188 22.7188 24 21.1429 24H6.85714C5.27902 24 4 22.7188 4 21.1429V6.85714C4 5.27902 5.27902 4 6.85714 4H21.1429ZM21.1429 6.85714H15.4286V12.5714H21.1429V6.85714ZM21.1429 15.4286H15.4286V21.1429H21.1429V15.4286ZM12.5714 12.5714V6.85714H6.85714V12.5714H12.5714ZM6.85714 21.1429H12.5714V15.4286H6.85714V21.1429Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol